export interface LocaleOption {
  id: string;
  shortLabel: string;
  label: string;
}

export class Locales {
  static readonly locales: LocaleOption[] = [
    {
      id: 'nl-NL',
      shortLabel: 'NL',
      label: 'Nederlands',
    },
    {
      id: 'en-US',
      shortLabel: 'EN',
      label: 'English',
    },
    {
      id: 'de-DE',
      shortLabel: 'DE',
      label: 'Deutsch',
    },
    {
      id: 'fr-FR',
      shortLabel: 'FR',
      label: 'Français',
    },
    {
      id: 'fi-FI',
      shortLabel: 'FI',
      label: 'Suomi',
    },
  ];

  static getLocales(): LocaleOption[] {
    return Locales.locales;
  }

  static getLocaleById(id: string): LocaleOption | undefined {
    return Locales.locales.find((locale) => locale.id === id);
  }

  static getLocaleByShortLabel(label: string): LocaleOption | undefined {
    return Locales.locales.find(
      (locale) => locale.shortLabel.toLowerCase() === label.toLowerCase(),
    );
  }
}
